import React from "react";
export default ({ className, onClick, disabled = false, color = null }) => (
  <svg
    style={{ minWidth: 17 }}
    width="17"
    height="17"
    viewBox="0 0 17 17"
    className={`${className || ""} ${disabled ? "disabled" : ""}`}
    onClick={onClick}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7072 0C11.2617 0 11.0386 0.538571 11.3536 0.853553L12.1867 1.68659C12.3819 1.88179 12.3819 2.19827 12.1868 2.39355L0.353337 14.2364C0.158208 14.4317 0.158271 14.7482 0.353478 14.9434L1.05665 15.6466C1.25186 15.8418 1.56833 15.8419 1.76362 15.6467L13.6065 3.81327C13.8018 3.61814 14.1183 3.61821 14.3135 3.81341L15.1465 4.64645C15.4615 4.96143 16.0001 4.73835 16.0001 4.29289V0.5C16.0001 0.223857 15.7762 0 15.5001 0H11.7072ZM6.23366 5.52389C6.43024 5.3287 6.43065 5.01089 6.23457 4.8152L1.76362 0.35287C1.5683 0.15793 1.25198 0.158083 1.05685 0.353212L0.353619 1.05645C0.158356 1.25171 0.158357 1.56829 0.353619 1.76355L4.81776 6.22769C5.01253 6.42247 5.32815 6.42303 5.52361 6.22894L6.23366 5.52389ZM15.2073 11.3415C15.5215 11.0257 16.0606 11.2474 16.0618 11.6928L16.0715 15.4857C16.0722 15.7619 15.849 15.9863 15.5728 15.987L11.7799 15.9968C11.3345 15.9979 11.11 15.4599 11.4242 15.1441L12.2483 14.3158C12.4456 14.1174 12.4418 13.7957 12.2398 13.6021L9.89262 11.3527C9.69025 11.1587 9.68682 10.8363 9.88502 10.6381L10.6685 9.85468C10.8645 9.6587 11.1825 9.65953 11.3774 9.85654L13.6695 12.1728C13.8648 12.3702 14.1835 12.3706 14.3793 12.1737L15.2073 11.3415Z"
      fill={color ? color : disabled ? "#4D4D4D" : "#fff"}
    />
  </svg>
);
